



































import { Component, Vue } from 'vue-property-decorator';
import DialogBase from '@/components/common/DialogBase.vue';
import { ErrorHandleStore } from '@/store/ErrorHandleStore';

@Component({
  components: {
    DialogBase,
  },
})
export default class MaintenanceDialog extends Vue {
  clickMain() {
    ErrorHandleStore().isMaintenance = false;
  }
}
